// noinspection SpellCheckingInspection
// List of surface types

const surfaceTypes = [
  'paved',
  'asphalt',
  'concrete',
  'concrete:lanes',
  'paving_stones',
  'sett',
  'unhewn_cobblestone',
  'cobblestone',
  'metal',
  'wood',
  'unpaved',
  'compacted',
  'fine_gravel',
  'gravel',
  'pebblestone',
  'ground',
  'grass'
]

export default surfaceTypes
